/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-26 15:44:38
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-09-11 09:25:39
 */

import { Button, Modal } from 'react-bootstrap';

import PropTypes from 'prop-types';
import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './SavedProjectConfirm.scss';

const SavedProjectConfirm = ({ show, onClose, onLeave, onSave, closeButton = true }) => {
  //const { show, onClose, onLeave, onSave, closeButton } = props;
  const closeHandler = () => {
    onClose();
  };
  const leaveHandler = () => {
    onLeave();
  };
  const saveHandler = () => {
    onSave();
  };
  return (
    <>
      <Modal
        show={show}
        onHide={() => {}}
        centered
        dialogClassName={`${styles['main-messagebox']} ${styles['main-savedprojectconfirm']}`}
        animation={false}>
        <Modal.Body className={styles['modal-body']}>
          <div className={styles['close-wrapper']}>
            {closeButton && (
              <Button className={styles['close-button']} onClick={closeHandler}>
                <span className={styles['close-button-text']}>×</span>
              </Button>
            )}
          </div>
          <div className={styles['content']}>Are you sure you want to leave without saving?</div>
        </Modal.Body>
        <Modal.Footer className={[styles['modal-footer'], isMobileOnly ? styles['mobile-modal-footer'] : ''].join(' ')}>
          <Button variant="link" className={styles['cancel']} onClick={closeHandler}>
            Cancel
          </Button>
          <Button variant="primary" className={styles['leave']} onClick={leaveHandler}>
            Leave without Saving
          </Button>
          <Button variant="primary" className={styles['save']} onClick={saveHandler}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

SavedProjectConfirm.propTypes = {
  show: PropTypes.bool,
  closeButton: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
// SavedProjectConfirm.defaultProps = {
//   closeButton: true,
// };
export default SavedProjectConfirm;
